import { render, staticRenderFns } from "./robotView3.vue?vue&type=template&id=6932187e&scoped=true"
import script from "./robotView3.vue?vue&type=script&lang=js"
export * from "./robotView3.vue?vue&type=script&lang=js"
import style0 from "./robotView3.vue?vue&type=style&index=0&id=6932187e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6932187e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6932187e')) {
      api.createRecord('6932187e', component.options)
    } else {
      api.reload('6932187e', component.options)
    }
    module.hot.accept("./robotView3.vue?vue&type=template&id=6932187e&scoped=true", function () {
      api.rerender('6932187e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/robotView3.vue"
export default component.exports